import React, { Component } from "react";
import { http, baseURL } from "../misc/http";
import history from "../misc/history";
import Layout from "../layout/Main";
import RunningText from "../components/Home/RunningText";
import Slider from "../components/Home/Slider";
import Organizer from "../components/Home/Organizer";
import BlogNArticle from "../components/Home/BlogNArticle";
import SocMed from "../components/Home/SocMed";
import Event from "../components/Home/Event";
import ListVideo from "../components/Home/ListVideo";
import InfoGraphic from "../components/Home/InfoGraphic";
import ListLogoOrganizer from "../components/Home/ListLogoOrganizer";
import ContactUs from "../components/Home/ContactUs";

export default class Home extends Component {
  state = {
    // listGallery : [],
    listOrganizer: [],
    listInfoGraphic: [],
    listEvent: [],
    listRunning: [],
    listBanner: [],
  };

  componentDidMount = () => {
    // this.handleGetAll('gallery?status=publish&limit=3', 'listGallery');
    // this.handleGetAll("organizer?limit=6", "listOrganizer");
    this.handleGetAll("settings/banner", "listBanner");
    this.handleGetAll("organizer", "listOrganizer");
    this.handleGetAll("infographic?status=publish", "listInfoGraphic");
    this.handleGetAll("events?limit=3", "listEvent");
    this.handleGetAll("events?eventType=webinar", "listRunning");
  };

  handleGetAll = async (path, stateName) => {
    let params = {
      method: "GET",
      path: path,
      showMessage: false,
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) {
      let stateData = this.state[stateName];
      stateData = data.data;
      this.setState({ [stateName]: stateData });
    }
  };

  goDetail = (url) => {
    history.push(url);
  };

  render() {
    return (
      <Layout>
        {this.state.listRunning.length > 0 && (
          <RunningText
            listRunning={this.state.listRunning}
            goDetail={this.goDetail}
          />
        )}
        <Slider
          props={this.props}
          listBanner={this.state.listBanner}
          baseURL={baseURL}
        />
        <Organizer listOrganizer={this.state.listOrganizer} />
        <BlogNArticle />
        <SocMed />
        <Event listEvent={this.state.listEvent} baseURL={baseURL} />
        <ListVideo />
        <InfoGraphic
          listInfoGraphic={this.state.listInfoGraphic}
          baseURL={baseURL}
        />
        <ListLogoOrganizer />
        <ContactUs />
      </Layout>
    );
  }
}
